import { render, staticRenderFns } from "./MedService.vue?vue&type=template&id=8aeedd1c&scoped=true"
import script from "./MedService.vue?vue&type=script&lang=js"
export * from "./MedService.vue?vue&type=script&lang=js"
import style0 from "./MedService.vue?vue&type=style&index=0&id=8aeedd1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aeedd1c",
  null
  
)

export default component.exports